<script setup>
import { computed } from 'vue'
import { Crown } from 'lucide-vue-next'
import { usePlanStore } from '@/stores/planStore'

const planStore = usePlanStore()

const props = defineProps({
  clickable: { type: Boolean, default: true },
  showIcon: { type: Boolean, default: true },
  size: { type: String, default: 'sm' }, // 'sm' | 'md'
})
const emit = defineEmits(['click'])

const sizeClass = computed(() => (props.size === 'md' ? 'text-sm px-3 py-1' : 'text-xs px-2.5 py-0.5'))
const showCrown = computed(() => props.showIcon && planStore.tier !== 'free')
</script>

<template>
  <component
    :is="clickable ? 'button' : 'span'"
    :type="clickable ? 'button' : undefined"
    class="pill font-semibold uppercase tracking-wide transition"
    :class="[planStore.definition.badgeClass, sizeClass, clickable ? 'hover:opacity-80 cursor-pointer' : 'cursor-default']"
    :aria-label="`Current plan: ${planStore.definition.label}`"
    @click="clickable && emit('click')"
  >
    <Crown v-if="showCrown" class="h-3 w-3" />
    {{ planStore.definition.label }}
  </component>
</template>
